import { API_DEMO_PRESENTATION_URL } from "../Utilities/Helper";
import { get, post } from "./AxiosService";

const Url = API_DEMO_PRESENTATION_URL;

export function saveGroupContact(data) {
  return post(`${Url}save_group_contact`, data).then((res) => res.data);
}

export function deleteGroupContact(groupName) {
  return post(`${Url}delete_group_contact`, { group_name: groupName }).then((res) => res.data);
}

export function getAllGroupMetadata() {
  return get(`${Url}get_all_group_metadata?_t=${Date.now()}`).then((res) => res.data);
}

export function fetchContactMetadata(metadataUrl) {
  return fetch(metadataUrl, {
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error fetching contact metadata:", error);
      throw error;
    });
}

export function sendMarketingEmail(data) {
  return post(`${Url}send_marketing_email`, data).then((res) => res.data);
}

// `section` is which part of the player the viewer just started ("intro" or
// "demo"), and only labels the team's alert. `notifyOnly` marks a move deeper
// into the player rather than a fresh arrival: it alerts without touching the
// view count or last-viewed stamp, which stay tied to the landing view.
export function logDemoViewed(videoId, source, section, notifyOnly) {
  const body = { video_id: videoId };
  if (source) body.source = source;
  if (section) body.section = section;
  if (notifyOnly) body.notify_only = true;
  return post(`${Url}demo_viewed`, body).then((res) => res.data);
}

export function fetchDemoMetadata(demo_id) {
  const metadataUrl = `https://elqmq.upcloudobjects.com/demo-videos/mod/${demo_id}_metadata.json`;
  return fetch(metadataUrl, {
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to fetch demo metadata");
      }
      return response.json();
    })
    .catch((error) => {
      console.error("Error fetching demo metadata:", error);
      throw error;
    });
}

export function generatePronunciationAudio(text) {
  const MINIMAX_API_TOKEN =
    "sk-api-GN-RHRVBuToqRQdZaHpy1btqBzN3e-c3oMCG5pe1lVKXI5fibfV7cS7wDBEPAYBCMcLDwopiEepxIuIW1EbZusin9bja_2fuFL47Re4TcceUOIB1YsQGF-4";

  return fetch("https://api.minimax.io/v1/t2a_v2", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${MINIMAX_API_TOKEN}`,
    },
    body: JSON.stringify({
      model: "speech-2.8-turbo",
      text: "The organization name is " + text,
      stream: false,
      voice_setting: {
        voice_id: "moss_audio_0900ae20-26d3-11f1-ae70-52038381a892",
        speed: 1.1,
        vol: 1,
        pitch: 0,
      },
      audio_setting: {},
      voice_modify: {
        pitch: 0,
        intensity: 0,
        timbre: 0,
      },
      effects: {
        deepen_lighten: -5,
        stronger_softer: -15,
        nasal_crisp: 0,
        spacious_echo: false,
        lofi_telephone: false,
        robotic: false,
        auditorium_echo: false
      },
      output_format: "url",
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to generate pronunciation audio");
      }
      return response.json();
    })
    .then((data) => {
      if (data.base_resp && data.base_resp.status_code !== 0) {
        throw new Error(
          data.base_resp.status_msg || "Failed to generate pronunciation audio"
        );
      }
      return data.data.audio;
    })
    .catch((error) => {
      console.error("Error generating pronunciation audio:", error);
      throw error;
    });
}
